import { createContext } from 'react';

const AuthContext = createContext({
  isAuthorized: true,
  onAuthorized: () => {},
  onUnauthorized: () => {},
});

export default AuthContext;
